/*
 * Sticky add to cart for the supply buy box (snippets/hydration-supply-buybox.liquid,
 * block setting "Sticky add to cart"). The theme's own sticky bar posts the
 * plain variant with no selling plan, so it stays hidden on these templates;
 * this one drives the buy box itself instead.
 *
 * - Shows once the buy box's add to cart has scrolled up out of view, so the
 *   shopper has seen the supply and subscribe options before it appears.
 * - Says what it will add (tier and subscribe or one-time) and mirrors the
 *   buy box button: its price, its ADDING... / ADDED states and its disabled
 *   state.
 * - A tap presses the buy box button, so the cart gets exactly what the buy
 *   box would add (items, plan, line properties) through the same code.
 */
(function () {
  if (customElements.get('supply-buybox-sticky')) return;

  class SupplyBuyboxSticky extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;

      this.container = document.getElementById(this.dataset.buyboxId);
      this.mainButton = this.container && this.container.querySelector('[data-supply-buybox-add-to-cart]');
      if (!this.mainButton) return;

      this.button = this.querySelector('[data-sticky-atc]');
      this.plan = this.querySelector('[data-sticky-plan]');

      // Fixed to the viewport, so it lives on <body>: inside the buy box
      // column it would share that column's stacking context.
      document.body.appendChild(this);

      this.mirrorButton();
      new MutationObserver(() => this.mirrorButton()).observe(this.mainButton, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled'],
      });

      this.syncPlan();
      this.container.addEventListener('change', () => this.syncPlan());

      this.button.addEventListener('click', () => {
        if (this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true') return;
        this.mainButton.click();
      });

      // Past the button (it is above the viewport), not before it. Checked
      // on scroll, once a frame, rather than with an IntersectionObserver:
      // that only reports when the button crosses the screen edge, so a fast
      // fling or a jump link from above the buy box to below it never
      // showed the bar.
      const check = () => {
        this.frame = 0;
        const rect = this.mainButton.getBoundingClientRect();
        this.setVisible(this.mainButton.getClientRects().length > 0 && rect.bottom < 0);
      };
      const schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(check);
      };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      check();
    }

    mirrorButton() {
      this.button.innerHTML = this.mainButton.innerHTML;
      const unavailable = this.mainButton.disabled;
      this.button.disabled = unavailable;
      if (this.mainButton.getAttribute('aria-disabled') === 'true') this.button.setAttribute('aria-disabled', 'true');
      else this.button.removeAttribute('aria-disabled');
    }

    syncPlan() {
      if (!this.plan) return;
      const mode = this.container.querySelector('.supply-buybox__mode-radio:checked');
      if (mode && mode.value === 'onetime') {
        const subtitle = this.container.querySelector('[data-onetime-subtitle]');
        const pack = subtitle ? subtitle.textContent.split('•')[0].trim() : '';
        this.plan.textContent = pack ? `One-time purchase · ${pack}` : 'One-time purchase';
        return;
      }
      const tier = this.container.querySelector('.supply-buybox__tier-radio:checked');
      const name = tier ? tier.dataset.planDisplayName || tier.dataset.planName : '';
      this.plan.textContent = name ? `${name} · Subscribe & save` : 'Subscribe & save';
    }

    setVisible(visible) {
      if (visible === this.visible) return;
      this.visible = visible;
      this.classList.toggle('is-visible', visible);
      this.inert = !visible;
      this.setAttribute('aria-hidden', String(!visible));
      // Lift the chat bubble clear of the bar, as the theme's sticky bar does.
      const chat = document.querySelector('iframe#chat-button');
      if (chat) chat.style.marginBottom = visible ? '5rem' : '0';
    }
  }

  customElements.define('supply-buybox-sticky', SupplyBuyboxSticky);
})();
